import React, {useEffect, useState} from 'react';

const About = () => {

//     const [show, setShow] = useState(false);
//    const handleClick = () => {
//     setShow(show => !show);
//    }

//    const toggleItem = ({discription, id}) => {
//     const [toggleThisElement, setToggleThisElement] = useState(false);

  return (
    <div name='about' className='w-full min-h-screen py-20 my-24 bg-[rgb(255,255,255)] text-black '>
        <div className='flex flex-col justify-center items-center w-full h-full'>
            <div className='max-w-[1000px] w-full grid grid-col-2 gap-8'>
                <div className='p-8 sm:text-right pb-8 pl-4'>
                    <p className='text-4xl font-bold inline border-b-2 border-[#d4d4d4] cursor-default'>About me</p>
                </div>

                <div className='max-w-[1000px] w-full grid sm:grid-col-2 gap-6 px-4'>
                    <div className='sm:text-right text-3xl font-bold'>
                        <p>Hi! I am Patryk Romański, nice to meet You! Please, take a look around.</p>
                    </div>
                    <div className='p-8 sm:text-right pb-6 pl-4'>
                            <button className='cursor-default text-2xl font-bold inline border-b-2 border-[#d4d4d4]'>Coding</button><br />
                        <div className='py-2 '>
                            <p>I have 2 years of experience in making sites. Within these 2 years, I learned a few websites. Now I am searching for clients to do new websites for them and searching for company where I will can develop my skills.</p>
                        </div>
                        <br />
                        <div>
                            <button className='cursor-default text-2xl font-bold inline border-b-2 border-[#d4d4d4]'>Video editing</button>
                            <div className='py-2'>
                                <p>Now, I am video editor too for my second thing that I am doing daily. For now, I'm working for company called PCC Poland that I am doing for them videos and looking for new clients.</p>
                            </div>
                        </div>
                            <h2 className='cursor-default text-2xl font-bold inline border-b-2 border-[#d4d4d4]'>What's next?</h2>
                        <div>
                            <p className='py-2'>What am I looking for in future? I will going to be FullStack developer and develop frameworks such as VueJs and NextJs. </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

   {/* <p>I am passionate about designing new websites and building them from scratches. I love too video editing. I specialize in creating high value content for new websites that can give a lot of new feelings and new clients for each one whose decide to make a new one site. What are You waiting for? Come with me and something nice!</p> */}

export default About